import { render, staticRenderFns } from "./FreeofCostSale.vue?vue&type=template&id=0877317c&"
import script from "./FreeofCostSale.vue?vue&type=script&lang=js&"
export * from "./FreeofCostSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports